export const flatCards = (cards = []) =>
  cards.reduce((acc, curVal) => {
    const mappedCards = (curVal?.data || []).map((details, index) => ({
      title: index === 0 ? curVal.title : '',
      ...details,
    }));

    return acc.concat(mappedCards);
  }, []);
